module.exports = __webpack_public_path__ + "media/src/images/mails/aecb36-ee48636e12d8daae68d491f42145957e.png";